import { render } from "./PromRequests.vue?vue&type=template&id=727ec249"
import script from "./PromRequests.vue?vue&type=script&lang=js"
export * from "./PromRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__